<template>
	<div @click.stop>
		<i v-if="isConfirming"
		   class="clickable hover text-danger fontello icon-trash"
		   :disabled="disabled"
		   @click="clickConfirm()"/>
		<i v-else
		   class="clickable hover text-muted fontello icon-cancel-circled2"
		   :disabled="disabled"
		   @click="clickOne()"/>
	</div>
</template>

<script>

	import BaseConfirmButton from "./BaseConfirmButton"

    export default {
        name: "CloseConfirm",
		extends: BaseConfirmButton,

		data: () => ({
		}),

		methods:{
		}
    }
</script>

<style>

</style>
